const isNewSub = (oldCtx, newCtx) => oldCtx?.s !== newCtx?.s;

export {isNewSub};
